import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AllowedThemeName } from '../../../constants/theme';
import { AppState } from '../../../store/reducers/root';
import { getSessionApplication } from '../../../store/selectors/session';
import { getCurrentThemeName } from '../../../store/selectors/theme';
import themeActions from '../../../store/slices/theme';
import userConfig from '../../../store/slices/userConfig';

import ThemePreferencesPane from './ThemePreferencesPane';

const mapStateToProps = (state: AppState) => ({
  theme: getCurrentThemeName(state),
  app: getSessionApplication(state),
});

const mapDispatchToProps = {
  onApplyTheme: themeActions.apply,
  onSaveGeneralConfig: userConfig.saveGeneral,
};

const mergeProps = (
  { app, theme }: ReturnType<typeof mapStateToProps>,
  { onApplyTheme, onSaveGeneralConfig }: typeof mapDispatchToProps
) => ({
  theme,
  onChangeTheme: (value: AllowedThemeName | null) => {
    if (value && app) {
      document.body.classList.add('theme-transitioning');

      onSaveGeneralConfig({ config: { theme: { [app]: value } } });
      onApplyTheme(value);

      setTimeout(() => {
        document.body.classList.remove('theme-transitioning');
      }, 300);
    }
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type ThemePreferencesPaneContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(ThemePreferencesPane);
